import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { generatePastelGradient } from '../utils/colorUtils';
import API_BASE from '../config';
import '../styles/Auth.css';

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [gradient, setGradient] = useState('');

  useEffect(() => { setGradient(generatePastelGradient()); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError('Passwords do not match'); return; }
    if (password.length < 6) { setError('Password must be at least 6 characters'); return; }

    setLoading(true); setError('');
    try {
      const res = await fetch(`${API_BASE}/auth/reset-password/${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password })
      });
      const data = await res.json();
      if (res.ok) {
        setSuccess(true);
      } else {
        setError(data.message || 'Reset failed');
      }
    } catch {
      setError('Network error – please try again');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container" style={{ background: gradient }}>
      <div className="auth-card">
        <h1>Staff IT</h1>
        <p className="auth-slogan">Bureaucracy made simple</p>
        <h2>Set New Password</h2>

        {success ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ background: '#d1fae5', color: '#065f46', padding: '12px 16px', borderRadius: 6, marginBottom: 16 }}>
              ✅ Password reset successfully!
            </div>
            <button className="btn-primary" onClick={() => navigate('/login')}>Go to Login</button>
          </div>
        ) : (
          <>
            {error && <div className="error-message">{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="password">New Password</label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  required
                  minLength={6}
                  disabled={loading}
                  placeholder="At least 6 characters"
                />
              </div>
              <div className="form-group">
                <label htmlFor="confirm">Confirm Password</label>
                <input
                  type="password"
                  id="confirm"
                  value={confirm}
                  onChange={e => setConfirm(e.target.value)}
                  required
                  disabled={loading}
                  placeholder="Repeat new password"
                />
              </div>
              <button type="submit" disabled={loading} className="btn-primary">
                {loading ? 'Resetting...' : 'Reset Password'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
